/* BBM Header JS — bbm-header.js */
/* ── Override Dawn's header height padding ──────────────────── */
(function() {
  function fixBodyPadding() {
    document.body.style.setProperty('padding-top', '0px', 'important');
    document.body.style.setProperty('margin-top', '0px', 'important');
    var main = document.getElementById('MainContent');
    if (main) {
      main.style.setProperty('padding-top', '0px', 'important');
      main.style.setProperty('margin-top', '0px', 'important');
    }
    // Remove PBar wrapper height
    var pbar = document.getElementById('PBarNextFrameWrapper');
    if (pbar) pbar.style.setProperty('display', 'none', 'important');
  }
  // Run immediately and after DOM changes
  fixBodyPadding();
  document.addEventListener('DOMContentLoaded', fixBodyPadding);
  // Watch for Dawn's JS adding padding dynamically
  var observer = new MutationObserver(fixBodyPadding);
  observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });
})();
document.addEventListener('DOMContentLoaded', function () {

  /* ── Scroll shadow ─────────────────────────────────────────── */
  var header = document.getElementById('bbm-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    });
  }

  /* ── Shop bar dropdowns ────────────────────────────────────── */
  var dropdowns = [
    { trigger: 'bbm-cat-trigger',     panel: 'bbm-cat-panel'     },
    { trigger: 'bbm-brand-trigger',   panel: 'bbm-brand-panel'   },
    { trigger: 'bbm-chassis-trigger', panel: 'bbm-chassis-panel' },
  ];

  dropdowns.forEach(function (item) {
    var wrap  = document.getElementById(item.trigger);
    var panel = document.getElementById(item.panel);
    var btn   = wrap && wrap.querySelector('.bbm-bar-btn');
    if (!wrap || !panel || !btn) return;

    var closeTimer;

    function openDrop() {
      clearTimeout(closeTimer);
      // Close others
      dropdowns.forEach(function (other) {
        if (other.trigger !== item.trigger) {
          var op = document.getElementById(other.panel);
          var ob = document.getElementById(other.trigger);
          var obt = ob && ob.querySelector('.bbm-bar-btn');
          if (op)  op.classList.remove('open');
          if (obt) obt.setAttribute('aria-expanded', 'false');
        }
      });
      panel.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }

    function closeDrop() {
      panel.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
    }

    wrap.addEventListener('mouseenter', function () { clearTimeout(closeTimer); openDrop(); });
    wrap.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeDrop, 150); });
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeDrop, 150); });

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      panel.classList.contains('open') ? closeDrop() : openDrop();
    });
  });

  // Close all on outside click / Escape
  document.addEventListener('click', function () {
    dropdowns.forEach(function (item) {
      var p = document.getElementById(item.panel);
      var b = document.getElementById(item.trigger);
      var bt = b && b.querySelector('.bbm-bar-btn');
      if (p)  p.classList.remove('open');
      if (bt) bt.setAttribute('aria-expanded', 'false');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.dispatchEvent(new MouseEvent('click'));
  });

  /* ── Category tabs ─────────────────────────────────────────── */
  document.querySelectorAll('.bbm-cat-tab').forEach(function (btn) {
    btn.addEventListener('mouseenter', function () {
      var cat = this.dataset.cat;
      var container = this.closest('.bbm-drop-cat-mega');
      container.querySelectorAll('.bbm-cat-tab').forEach(function (b) { b.classList.remove('on'); });
      container.querySelectorAll('.bbm-cat-panel').forEach(function (p) { p.classList.remove('on'); });
      this.classList.add('on');
      var target = container.querySelector('[data-panel="' + cat + '"]');
      if (target) target.classList.add('on');
    });
  });

  /* Chassis tabs now use bbm-cat-tab — handled above */

  /* ── Mobile hamburger ──────────────────────────────────────── */
  var hamburger = document.getElementById('bbm-hamburger');
  var drawer    = document.getElementById('bbm-mobile-drawer');
  var overlay   = document.getElementById('bbm-overlay');
  var mclose    = document.getElementById('bbm-mobile-close');

  function openDrawer() {
    drawer  && drawer.classList.add('open');
    overlay && overlay.classList.add('show');
    hamburger && hamburger.classList.add('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    drawer  && drawer.classList.remove('open');
    overlay && overlay.classList.remove('show');
    hamburger && hamburger.classList.remove('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'false');
  }

  hamburger && hamburger.addEventListener('click', function (e) {
    e.stopPropagation();
    drawer && drawer.classList.contains('open') ? closeDrawer() : openDrawer();
  });
  mclose  && mclose.addEventListener('click', closeDrawer);
  overlay && overlay.addEventListener('click', closeDrawer);

});
